<div>
   <p *ngIf="form['error'] == false && form['message']">
      <app-ncs-alert [message]="form['message']" type="success" />
   </p>
   <p *ngIf="form['error'] ==  true && form['message']">
      <app-ncs-alert [message]="form['message']" type="danger" />
   </p>
</div>
<form #uiForm="ngForm" class="row g-3 align-items-center compact-inputs pb-1">
   <!-- Role Selector -->
   <div class="col-xl-3 col-lg-6 col-md-12">
      <mat-form-field appearance="outline" class="w-100 dropdown-pd-none">
         <mat-label>{{ 'roleAccess.form.selectors.role' | translate }}</mat-label>
         <mat-select name="applicationRoleId" [(ngModel)]="form.data['applicationRoleId']" required
            (selectionChange)="convertStringToNumber('applicationRoleId'); onRoleChange()" #applicationRoleId="ngModel">
            <mat-option disabled [value]="undefined">
               {{ 'roleAccess.form.selectors.role' | translate }}
            </mat-option>
            <mat-option *ngFor="let c of applicationsroles" [value]="c.id">
               {{ c.name }}
            </mat-option>
         </mat-select>
      </mat-form-field>
   </div>

   <!-- Access Type Selector -->
   <div class="col-xl-3 col-lg-6 col-md-12">
      <mat-form-field appearance="outline" class="w-100 dropdown-pd-none">
         <mat-label>{{ 'roleAccess.form.selectors.accessType' | translate }}</mat-label>
         <mat-select name="accessType" [(ngModel)]="form.data['accessType']" required #accessType="ngModel">
            <mat-option disabled [value]="undefined">
               {{ 'roleAccess.form.selectors.accessType' | translate }}
            </mat-option>
            <mat-option *ngFor="let c of availableAccessTypes" [value]="c">
               {{ c }}
            </mat-option>
         </mat-select>
      </mat-form-field>
   </div>

   <!-- Permissions Checkboxes -->
   <div class="col-xl-6 col-lg-6 col-md-12 d-flex flex-wrap align-items-center gap-3 ps-2">
      <div class="d-flex align-items-center">
         <mat-checkbox color="primary" id="create" name="create" [(ngModel)]="form.data['create']"
            (change)="convertBooleanToNumber('create')" class="me-1">
         </mat-checkbox>
         <label for="create" class="form-check-label mb-0">
            {{ 'roleAccess.form.permissions.create' | translate }}
         </label>
      </div>

      <div class="d-flex align-items-center">
         <mat-checkbox color="primary" id="update" name="update" [(ngModel)]="form.data['update']"
            (change)="convertBooleanToNumber('update')" class="me-1">
         </mat-checkbox>
         <label for="update" class="form-check-label mb-0">
            {{ 'roleAccess.form.permissions.update' | translate }}
         </label>
      </div>

      <div class="d-flex align-items-center">
         <mat-checkbox color="primary" id="read" name="read" [(ngModel)]="form.data['read']"
            (change)="convertBooleanToNumber('read')" class="me-1">
         </mat-checkbox>
         <label for="read" class="form-check-label mb-0">
            {{ 'roleAccess.form.permissions.read' | translate }}
         </label>
      </div>

      <div class="d-flex align-items-center">
         <mat-checkbox color="primary" id="delete" name="delete" [(ngModel)]="form.data['delete']"
            (change)="convertBooleanToNumber('delete')" class="me-1">
         </mat-checkbox>
         <label for="delete" class="form-check-label mb-0">
            {{ 'roleAccess.form.permissions.delete' | translate }}
         </label>
      </div>
   </div>

   <div class="col-auto">
      <div class="d-flex justify-content-lg-end justify-content-md-start gap-2 mt-2 mt-sm-0">
         <button mat-stroked-button color="primary" [title]="'roleAccess.form.buttons.save' | translate"
            [disabled]="uiForm.invalid" (click)="addAccess()">
            <mat-icon>save</mat-icon>
            <span>{{ 'roleAccess.form.buttons.save' | translate }}</span>
         </button>

         <button mat-stroked-button color="primary" [title]="'roleAccess.form.buttons.addNew' | translate"
            (click)="resetForm()">
            <mat-icon>add</mat-icon>
            <span>{{ 'roleAccess.form.buttons.addNew' | translate }}</span>
         </button>

         <span class="text-danger">{{ form.inputerror["applicationRoleId"] }}</span>
      </div>
   </div>
</form>

<!-- table form -->
<div class="table-container my-3">
   <div class="table-responsive table-scrollable">
      <table class="table table-bordered table-hover table-sticky-header">
         <thead class="table-light">
            <tr>
               <th class="text-center">{{ 'roleAccess.table.headers.sno' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.applicationRole' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.accessType' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.create' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.update' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.read' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.delete' | translate }}</th>
               <th>{{ 'roleAccess.table.headers.action' | translate }}</th>
            </tr>
         </thead>
         <tbody>
            <tr *ngFor="let accessType of saveAccessList; let i = index">
               <td class="text-center">{{ pageIndex(i) }}</td>
               <td>{{ appliationRoleName }}</td> <!-- Fixed closing tag -->
               <td>{{ accessType }}</td>
               <td>{{ getPermissionValue(accessType, 'create') == 1 ? ('roleAccess.table.values.yes' | translate) :
                  ('roleAccess.table.values.no' | translate) }}</td>
               <td>{{ getPermissionValue(accessType, 'update') == 1 ? ('roleAccess.table.values.yes' | translate) :
                  ('roleAccess.table.values.no' | translate) }}</td>
               <td>{{ getPermissionValue(accessType, 'read') == 1 ? ('roleAccess.table.values.yes' | translate) :
                  ('roleAccess.table.values.no' | translate) }}</td>
               <td>{{ getPermissionValue(accessType, 'delete') == 1 ? ('roleAccess.table.values.yes' | translate) :
                  ('roleAccess.table.values.no' | translate) }}</td>
               <td>
                  <button mat-stroked-button color="warn" [title]="'roleAccess.table.actions.delete' | translate"
                     (click)="removeAccess(i)" class="icon-center icon-width">
                     <mat-icon class="icon-compact">delete</mat-icon>
                  </button>
               </td>
            </tr>
         </tbody>
      </table>
   </div>
</div>
<app-list-header [$parent]="getSelf()"></app-list-header>